import React, { useEffect, useState } from 'react';

//*MUI
import { Box, Modal } from '@mui/material';

//*files
import cssClasses from './SdrchangeUnitsModal.module.css';
import Close from '../../Components/Icons/Close';
import { DataGrid } from '@mui/x-data-grid';
import Button from '../../Subcomponents/Button';
import LeadStatusChip from '../../Subcomponents/LeadStatusChip';
import Dot from '../../Components/Icons/Dot';
import axios from 'axios';
import { AllotmentDiv } from '../../Subcomponents/FloorComponent/FloorComponents';
import { dismissLoader, presentLoader } from '../../Services/loader';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import actions from '../../Redux Store/actions';
import { orderBy } from 'lodash';

const dataGridStyles = {
  '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  border: '1px solid #EAECF0 !important',
  fontWeight: '400',
  fontSize: '1.4rem',
  lineHeight: '2rem',
  color: '#667085',
  fontFamily: 'Inter-Medium',
  borderRadius: '8px',
  '& div[data-colindex="1"]': {
    color: '#101828',
    fontWeight: '500',
  },
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    '& .MuiDataGrid-row': {
      borderBottom: '1px solid #EAECF0',
      background: '#FFFFFF',
      /* Shadow/xl */

      // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      borderRadius: '1rem',

      //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
      //   backgroundColor: "#FFFFFF",
    },
    '& .MuiDataGrid-row.Mui-selected:hover': {
      borderBottom: '1px solid #EAECF0',
      backgroundColor: '#FFFFFF',
      // "&:nth-of-type(2n+1)": {
      //   backgroundColor: "rgba(249, 250, 251, 1)",
      // },
    },
  },
  '& .MuiDataGrid-iconSeparator ': {
    display: 'none',
  },
  '& .MuiDataGrid-columnHeader:hover': {
    '& .MuiDataGrid-menuIcon': {
      visibility: 'hidden',
    },
  },

  '&  .MuiDataGrid-columnHeaders': {
    background: '#F9FAFB',
    /* Gray/200 */
    border: '1px solid #EAECF0',
    /* Shadow/xl */
    // boxShadow:
    //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    // borderRadius: "8px",

    marginBottom: '1rem',
    borderBottom: '6px solid #EAECF0',
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-checkboxInput': {
    '& svg': {
      width: '2rem',
      height: '2rem',
      background: '#FFFFFF',
    },
  },
  // "& .MuiTablePagination-displayedRows": {
  //   display: "none",
  // },
  '& .MuiDataGrid-footerContainer': {
    '& .MuiTablePagination-displayedRows ': {
      display: 'none',
    },
    '& .MuiDataGrid-selectedRowCount': {
      visibility: 'hidden ',
    },
  },
  "&  [title='Sort']": {
    //visibility:"hidden",
    display: 'none',
    cursor: 'none',
  },
  "& [title='Go to previous page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to next page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to previous page']:after": {
    content: "'Previous'",
    marginLeft: '1rem',
  },
  "& [title='Go to next page']:before": {
    content: "'Next'",
    marginRight: '1rem',
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 4rem',

    '&:focus': {
      outline: 'none',
    },
  },
  '&  .MuiDataGrid-row ': {
    maxHeight: '72px !important',
    minHeight: '72px !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 4rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiButtonBase-root': {
    fontSize: '1.6rem',
  },
  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 2rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 1rem',

    '&:focus': {
      outline: 'none',
    },
  },
};
function SdrChangeUnitsModal({
  open,
  handleClose,
  data,
  oldSdrPercent,
  newSdrPercent,
  responseValue,
  legalChargesVal,
  registrationChargesVal,
}) {
  let loggedInUser = useSelector((state) => state.Auth.user);
  const dispatch = useDispatch();
  const [UnitCostData, setUnitCostData] = useState([]);
  const [pageMaintain, setPageMaintain] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -55%)',
    width: '70%',
    height: '80%',
    bgcolor: 'background.paper',
    borderRadius: '8px',
    boxShadow: 24,
  };

  useEffect(() => {
    const map_arr = data.map((elm) => ({
      ...elm,
      id: elm.unitId,
      oldSdrVal: (Math.ceil(Math.round((Number(elm.BSP) * oldSdrPercent) / 100) / 100) * 100) +
        (elm.BSP > 3000000
          ? (Math.ceil(Number(registrationChargesVal / 100) * 100))
          : (Math.ceil(Number(elm.BSP / 100) / 100) * 100)) +
        legalChargesVal
      ,
      newSdrVal: (Math.ceil(Math.round((Number(elm.BSP) * newSdrPercent) / 100) / 100) * 100) +
        (Number(elm.BSP) > 3000000
          ? (Math.ceil(Number(registrationChargesVal / 100) * 100))
          : (Math.ceil(Number(elm.BSP / 100) / 100) * 100)) +
        legalChargesVal,
    }));
    const sortedUnits = orderBy(map_arr, [(em) => em.unitNo], ['asc']);
    setUnitCostData(sortedUnits);
  }, [newSdrPercent]);

  function getMoreData() { }

  function numDifferentiation(val) {
    if (val >= 10000000) val = (val / 10000000).toFixed(2) + ' Cr';
    else if (val >= 100000) val = (val / 100000).toFixed(2) + ' Lac';
    else if (val >= 1000) val = (val / 1000).toFixed(2) + ' K';
    return val;
  }

  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',');
  }

  const SdrColumns = [
    {
      field: 'Wing',
      headerName: 'Wing',
      width: 130,
      renderCell: (params) => {
        return (
          <Box>
            <Box className={cssClasses.innerTitle}>
              {params.row.wingId.wingName}
            </Box>
          </Box>
        );
      },
    },
    {
      field: 'UnitNo',
      headerName: 'Unit No',
      width: 100,
      renderCell: (params) => {
        return (
          <Box>
            <Box className={cssClasses.innerTitle}>{params.row.unitNo}</Box>
          </Box>
        );
      },
    },
    {
      field: 'Status',
      headerName: 'Status',
      width: 180,
      renderCell: (params) => {
        return (
          <Box>
            {params.row.InventoryStatus?.status === 'On Hold' && (
              <LeadStatusChip
                style={{
                  color: '#B54708',
                  backgroundColor: '#FEF0C7',
                }}
                label={params.row.InventoryStatus?.status}
                icon={<Dot width={'0.6rem'} height={'0.6rem'} />}
              />
            )}
            {params.row.InventoryStatus?.status === 'Reserved' && (
              <LeadStatusChip
                style={{
                  color: '#6941C6',
                  backgroundColor: '#F4EBFF',
                }}
                label={params.row.InventoryStatus?.status}
                icon={<Dot width={'0.6rem'} height={'0.6rem'} />}
              />
            )}
            {params.row.InventoryStatus?.status === 'Locked' && (
              <LeadStatusChip
                style={{
                  color: '#344054',
                  backgroundColor: '#F2F4F7',
                }}
                label={params.row.InventoryStatus?.status}
                icon={<Dot width={'0.6rem'} height={'0.6rem'} />}
              />
            )}
            {params.row.InventoryStatus?.status === 'Available' && (
              <LeadStatusChip
                style={{
                  color: '#027A48',
                  backgroundColor: '#D1FADF',
                }}
                label={params.row.InventoryStatus?.status}
                icon={<Dot width={'0.6rem'} height={'0.6rem'} />}
              />
            )}
            {params.row.InventoryStatus?.status === 'Preselected' && (
              <LeadStatusChip
                style={{
                  color: '#FF4405',
                  backgroundColor: '#FFE6D5',
                }}
                label={params.row.InventoryStatus?.status}
                icon={<Dot width={'0.6rem'} height={'0.6rem'} />}
              />
            )}
            {params.row.InventoryStatus?.status === 'Payment Pending' && (
              <LeadStatusChip
                style={{
                  color: '#B42318',
                  backgroundColor: '#FEE4E2',
                }}
                label={params.row.InventoryStatus?.status}
                icon={<Dot width={'0.6rem'} height={'0.6rem'} />}
              />
            )}
            {params.row.InventoryStatus?.status === 'Kyc Pending' && (
              <LeadStatusChip
                style={{
                  color: '#0E7090',
                  backgroundColor: '#ECFDFF',
                }}
                label={params.row.InventoryStatus?.status}
                icon={<Dot width={'0.6rem'} height={'0.6rem'} />}
              />
            )}

            {params.row.InventoryStatus?.status === 'Kyc Done' && (
              <LeadStatusChip
                style={{
                  color: '#2E90FA',
                  backgroundColor: '#D1E9FF',
                }}
                label={params.row.InventoryStatus?.status}
                icon={<Dot width={'0.6rem'} height={'0.6rem'} />}
              />
            )}
          </Box>
        );
      },
    },
    {
      field: 'UnitCost',
      headerName: 'Unit Cost',
      width: 120,
      renderCell: (params) => {
        return (
          <Box>
            <Box className={cssClasses.innerTitle}>{`₹${numDifferentiation(
              params.row.totalCost
            )}`}</Box>
          </Box>
        );
      },
    },
    {
      field: 'oldSDR',
      headerName: `Old SDR Percentage`,
      width: 200,
      renderCell: (params) => {
        return (
          <Box>
            <Box className={cssClasses.innerTitle}>{`₹${numberWithCommas(
              params.row.oldSdrVal
            )}`}</Box>
          </Box>
        );
      },
    },
    {
      field: 'newSdr',
      headerName: `New Sdr Percentage(${newSdrPercent}%)`,
      width: 200,
      renderCell: (params) => {
        return (
          <Box>
            <Box className={cssClasses.innerTitle}>{`₹${numberWithCommas(
              params.row.newSdrVal
            )}`}</Box>
          </Box>
        );
      },
    },
  ];

  function onSubmit() {
    console.log('data.projectId', data[0]?.projectId);
    dispatch(actions.ProjectFlag(true));
    presentLoader();
    axios
      .get(process.env.REACT_APP_PAYMENT_LINK_URL + 'units/getToken')
      .then((resp) => {
        axios
          .post(
            process.env.REACT_APP_PAYMENT_LINK_URL +
            `units/updateInventoryPriceForSdrChange?token=${resp.data.token}`,
            {
              projectId: data[0].projectId,
              sdrPercentage: newSdrPercent,
              userId: loggedInUser.userId,
              oldSdrPercent: oldSdrPercent,
            }
          )
          .then((updateRes) => {
            if (updateRes) {
              console.log('updateRes', updateRes);
              axios
                .get(
                  process.env.REACT_APP_PAYMENT_LINK_URL +
                  `units/getCount?token=${resp.data.token}`
                )
                .then((countResp) => {
                  console.log('countResp', countResp);
                  responseValue(true);
                  dispatch(actions.ProjectFlag(false));
                  handleClose();
                  dismissLoader();
                });
            }
          });
      });
  }

  function closeModal() {
    handleClose();
  }

  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') {
          handleClose();
        }
      }}
    >
      <Box sx={style}>
        <Box className={cssClasses.headerDiv}>
          <Box className={cssClasses.flexRow}>
            <Box className={cssClasses.flexCol}>
              <Box className={cssClasses.HeaderTitle} mt={1}>
                SDR Percentage({UnitCostData?.length})
              </Box>{' '}
            </Box>
            <Box
              ml={'auto'}
              mt={1}
              onClick={handleClose}
              style={{ cursor: 'pointer' }}
            >
              <Close width={'1.2rem'} height={'1.2rem'} />
            </Box>
          </Box>
        </Box>
        <Box className={cssClasses.BoxDiv} mt={2}>
          <AllotmentDiv
            style={{ backgroundColor: '#D1FADF' }}
            content={'Available'}
            Quantity={
              UnitCostData
                ? UnitCostData?.filter((f) => f.InventoryStatus.status === 'Available')
                  .length
                : '0'
            }
          />
          <AllotmentDiv
            style={{ backgroundColor: '#FEF0C7' }}
            content={'On Hold'}
            Quantity={
              UnitCostData
                ? UnitCostData?.filter((f) => f.InventoryStatus.status === 'On Hold')
                  .length
                : '0'
            }
          />
          <AllotmentDiv
            style={{ backgroundColor: '#FEE4E2' }}
            content={'Payment Pending'}
            // content={"Alloted"}
            Quantity={
              UnitCostData
                ? UnitCostData?.filter(
                  (f) => f.InventoryStatus.status === 'Payment Pending'
                ).length
                : '0'
            }
          />

          <AllotmentDiv
            style={{ backgroundColor: '#FFE6D5' }}
            content={'Preselected'}
            Quantity={
              UnitCostData
                ? UnitCostData?.filter(
                  (f) => f.InventoryStatus.status === 'Preselected'
                ).length
                : '0'
            }
          />

          <AllotmentDiv
            style={{ backgroundColor: '#EFF8FF' }}
            content={'Kyc Pending'}
            Quantity={
              UnitCostData
                ? UnitCostData?.filter(
                  (f) => f.InventoryStatus.status === 'Kyc Pending'
                ).length
                : '0'
            }
          />
          <AllotmentDiv
            style={{ backgroundColor: '#D1E9FF' }}
            content={'Kyc Done'}
            Quantity={
              UnitCostData
                ? UnitCostData?.filter((f) => f.InventoryStatus.status === 'Kyc Done')
                  .length
                : '0'
            }
          />
          <AllotmentDiv
            style={{ backgroundColor: '#FFFAEB' }}
            content={'SDR Payment Pending'}
            Quantity={
              UnitCostData
                ? UnitCostData?.filter(
                  (f) => f.InventoryStatus.status === 'SDR Payment Pending'
                ).length
                : '0'
            }
          />
          <AllotmentDiv
            style={{ backgroundColor: '#F4EBFF' }}
            content={'Reserved'}
            Quantity={
              UnitCostData
                ? UnitCostData?.filter((f) => f.InventoryStatus.status === 'Reserved')
                  .length
                : '0'
            }
          />
          <AllotmentDiv
            style={{ backgroundColor: '#F2F4F7' }}
            content={'Locked'}
            Quantity={
              UnitCostData
                ? UnitCostData?.filter((f) => f.InventoryStatus.status === 'Locked')
                  .length
                : '0'
            }
          />
          <AllotmentDiv
            style={{ backgroundColor: 'rgb(249 171 165)' }}
            content={'Sold'}
            Quantity={
              UnitCostData
                ? UnitCostData?.filter((f) => f.InventoryStatus.status === 'Sold')
                  .length
                : '0'
            }
          />
        </Box>

        <Box height={'63%'} overflow={'auto'} margin={'0rem 2rem 1rem 2rem'}>
          <DataGrid
            rows={UnitCostData}
            columns={SdrColumns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            page={pageMaintain}
            onPageChange={(_page) => {
              console.log(_page);
              setPageMaintain(_page);
              if (pageNumber < _page) {
                getMoreData(_page);
              }
            }}
            sx={[dataGridStyles]}
          />
        </Box>

        <Box className={cssClasses.FooterDiv}>
          <Box className={cssClasses.flexRow}>
            <Box width={'fit-Content'} ml={'auto'}>
              <Button
                style={{
                  color: '#344054',
                  backgroundColor: '#ffffff',
                  fontSize: '1.6rem',
                  lineHeight: '2.4rem',
                }}
                padding={'0.85rem 2.6rem'}
                btnName={'Cancel'}
                clicked={closeModal}
              />
            </Box>

            <Box width={'fit-Content'}>
              <Button
                style={{
                  fontSize: '1.6rem',
                  lineHeight: '2.4rem',
                  color: '#ffffff',
                  backgroundColor: '#155EEF',
                }}
                padding={'0.85rem 3rem'}
                disable={data.length === 0}
                btnName={'Update'}
                clicked={onSubmit}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

export default SdrChangeUnitsModal;
